import styled from 'styled-components';
import ThinDivider from '../ThinDivider';

export const ExecutionSplitLine = styled(ThinDivider).attrs({
  layout: 'horizontal',
  size: 'full',
})`
  margin-top: 24px;
  margin-bottom: 24px;
`;
